import { Input, Output } from '@angular/core'
import { Component, EventEmitter } from '@angular/core'
import { Magazine } from 'src/lib/entity/magazine'
import {Live} from 'src/lib/entity/live'

@Component({
  selector: 'maglive-player-overlay-dialog',
  templateUrl: './player-overlay-dialog.component.html',
  styleUrls: ['./player-overlay-dialog.component.scss']
})
export class PlayerOverlayDialogComponent {

  @Input() reason: 'NO_STREAM' | 'RESERVED'
  @Input() private magazine: Magazine | string
  @Input() following: Boolean
  @Input() private live: Live | string
  @Output() followEvent: EventEmitter<Boolean> = new EventEmitter()
  @Output() toggleDialogEvent: EventEmitter<void> = new EventEmitter()

  get _magazine(): Magazine {
    if (typeof this.magazine === 'string') {
      return null;
    }
    return this.magazine;
  }

  get _live(): Live {
    if (typeof this.live === 'string') {
      return null;
    }
    return this.live;
  }

  get scheduledAt(): string | null {
    if (typeof this.live === 'string') {
      return null;
    }
    if (this.live.scheduledAt === null) {
      return null;
    }
    const date = this.live.scheduledAt.toDate();
    return date.getFullYear() + '/' + (date.getMonth() + 1) + "/" + date.getDate() + " " + date.getHours() + ":" + ('00' + date.getMinutes()).slice(-2);
  }

  get shareURL(): string {
    return encodeURIComponent(location.href);
  }

  get shareText(): string {
    return encodeURIComponent(`【${this.scheduledAt}開始予定】 ${this._live.title}`);
  }

  get shareTags(): string {
    return encodeURIComponent('まぐまぐLive');
  }

  toggleModal() {
    this.toggleDialogEvent.emit()
  }

  onFollowClick(following) {
    this.followEvent.emit(following)
    return false
  }
}
